import { graphql, useStaticQuery } from 'gatsby';
import BussinesHistorical from '@/components/organisms/bussines-historical/bussines-historical';

const HistoricoAfiliacionAComfamaEmpresas = () => {
    const data = useStaticQuery(graphql`
        query GET_PORTAL_SERVICIOS_HISTORICO_AFILIACION_EMPRESAS {
            allContentfulTemplate(
                filter: {
                    titulo: {
                        eq: "Internas de certificados empresas > Histórico de afiliaciones a Comfama Empresas"
                    }
                }
            ) {
                nodes {
                    nombre
                    titulo
                    metaInfo {
                        metaTitulo
                        metaDescripcion
                        metaImagen {
                            file {
                                url
                            }
                        }
                        urlCanonical
                        noIndex
                    }
                    migaDePan
                    serviceId
                    nombre
                    imagen {
                        file {
                            url
                        }
                        gatsbyImage(width: 700, formats: [AUTO, WEBP], placeholder: BLURRED)
                    }
                    estaActivo
                    descripcion {
                        raw
                    }
                    referencias {
                        ... on ContentfulTemplate {
                            nombre
                            subtitulo
                            tituloEnriquecido {
                                raw
                            }
                            lista
                            imagen {
                                title
                                file {
                                    url
                                }
                                gatsbyImage(width: 700, formats: [AUTO, WEBP], placeholder: BLURRED)
                            }
                            imagen {
                                file {
                                    url
                                }
                                gatsbyImage(width: 700, formats: [AUTO, WEBP], placeholder: BLURRED)
                            }
                            descripcion {
                                raw
                            }
                            spanMagenta
                            copyBoton
                            redireccion
                            type
                            listaJson {
                                name
                                value
                            }
                        }
                    }
                }
            }
        }
    `);
    return (
        <BussinesHistorical dataQuery={data.allContentfulTemplate.nodes[0]} />
    );
};

export default HistoricoAfiliacionAComfamaEmpresas;
